"use strict";
// This file contains objects documented here: https://api.slack.com/reference/block-kit/block-elements
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=block-elements.js.map